const version = '0.5.0';
export default version;
